// extracted by mini-css-extract-plugin
module.exports =  {"root":"CpvOAwCNZuXhni3vM98T"};